module.exports = __webpack_public_path__ + "img/linkem_icons_assist.b15feaff.png";